import { render, staticRenderFns } from "./StatisticCounter.vue?vue&type=template&id=1f6912c6&scoped=true&"
import script from "./StatisticCounter.vue?vue&type=script&lang=js&"
export * from "./StatisticCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6912c6",
  null
  
)

export default component.exports